module.exports = __webpack_public_path__ + "static/media/color_fondo1.49dd611d.png";